import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

const button = cva(
  "inline-flex items-center justify-center gap-2 font-medium transition-all duration-150 cursor-pointer disabled:pointer-events-none disabled:opacity-50 select-none",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-primary-fg hover:opacity-95 active:scale-[0.98] shadow-xs hover:shadow",
        secondary:
          "border border-border bg-surface text-fg hover:bg-surface-subtle active:scale-[0.98] shadow-xs",
        ghost: "text-fg hover:bg-surface-subtle active:scale-[0.98]",
        danger: "bg-danger text-primary-fg hover:opacity-90 active:scale-[0.98] shadow-xs",
      },
      size: {
        sm: "h-8 px-3 text-xs rounded-md",
        md: "h-9 px-3.5 text-sm rounded-lg",
        icon: "h-9 w-9 rounded-lg shrink-0",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof button> {
  asChild?: boolean;
}

export function Button({
  className,
  variant,
  size,
  asChild,
  type = "button",
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      type={asChild ? undefined : type}
      className={cn(button({ variant, size }), className)}
      {...props}
    />
  );
}
